import React from 'react';
import { Text, Flex } from 'components';

const NameAgeDisplay = props => {
  const { name, age } = props;
  return (
    <Flex pb={[2]} alignItems="center">
      <Text fontSize={[1]} color="white" fontWeight="bold" lineHeight="0.1">
        {name}
      </Text>
      <Text fontSize={[1]} color="white" lineHeight="0.1">{`, ${age} år`}</Text>
    </Flex>
  );
};

export default NameAgeDisplay;
